import React from "react";

import nary from "@/modules/nary";
import { assetImg } from "@/modules/moduleImporter";
import { IGenericHistoryType } from "@/types/GameHistoryTypes";

import "@/styles/machine_game_statistics.scss";

interface IProps {
	history: IGenericHistoryType[];
	mobile?: boolean;
}

//Copied from m26
//Unusual component: doesn't follow the GameStatistics standards
export default class M30 extends React.Component<IProps> {
	render() {
		const output = {};

		//Initialises output
		[...Array(10).keys()].forEach(num => { output[num] = 0; });

		this.props.history.map(item => item.angka.split(","))
			.forEach(item => output[item[0]]++); //.forEach(subItem => output[subItem]++));

		const total = this.props.history.length;

		return (
			<div className="game-statistics machine-game-statistics m26-statistics">
				{
					this.props.mobile ? (
						nary(5).map((_num, idx) =>
							<div className="row" key={"GS_m26_" + idx}>
								<div>
									{assetImg("m30", (idx) + "")}
									<div>
										{Math.round(output[idx] / total * 100)} %
								</div>
								</div>

								<div>
									{assetImg("m30", (idx + 5) + "")}
									<div>
										{Math.round(output[idx] / total * 100)} %
								</div>
								</div>
							</div>
						)
					) : (
							nary(5).map((_num, idx) =>
								<div className="row" key={"GS_m26_" + idx}>
									<div>
										{assetImg("m30", (idx * 2) + "")}
										<div>
											{Math.round(output[idx * 2] / total * 100)} %
									</div>
									</div>

									<div>
										{assetImg("m30", (idx * 2 + 1) + "")}
										<div>
											{Math.round(output[idx * 2 + 1] / total * 100)} %
									</div>
									</div>
								</div>
							)
						)
				}
			</div>
		);
	}
}